import { StyledCircularProgressBar, type DataAttributes } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export type ViewportProps = DataAttributes<{
	variant: "loading" | "overlay" | "canvas";
}>;

export const ErrorContent = styled.div``;
export const ErrorTitle = styled.p``;
export const ErrorMessage = styled.p``;
export const Canvas = styled.canvas``;
export const ARButtonContainer = styled.div``;

export const Viewport = styled.div<ViewportProps>`
	${() => css`
		width: 100vw;
		height: 100vh;
		height: 100dvh;
		background: transparent;

		&[data-variant="loading"] {
			display: flex;
			align-items: center;
			justify-content: center;
			background: #ffffff;

			${StyledCircularProgressBar.Buffering} ${StyledCircularProgressBar.SvgCircle} circle,
			${StyledCircularProgressBar.Buffer} ${StyledCircularProgressBar.SvgCircle} circle,
			${StyledCircularProgressBar.Value} ${StyledCircularProgressBar.SvgCircle} circle {
				stroke: #444444;
			}
		}

		&[data-variant="overlay"] {
			display: flex;
			align-items: center;
			justify-content: center;
			background: rgba(0, 0, 0, 0.75);
			color: #ffffff;
			font-family: sans-serif;
		}

		&[data-variant="canvas"] {
			position: relative;
		}

		${ErrorContent} {
			text-align: center;
			max-width: 480px;
		}

		${ErrorTitle} {
			font-weight: bold;
			margin-bottom: 8px;
		}

		${ErrorMessage} {
			opacity: 0.7;
		}

		${Canvas} {
			width: 100%;
			height: 100%;
			background: transparent;
		}

		${ARButtonContainer} {
			position: absolute;
			bottom: calc(24px + env(safe-area-inset-bottom, 0px));
			left: calc(24px + env(safe-area-inset-left, 0px));
		}
	`}
`;
